import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { fetchReviewHistory } from '../api/review.api';
import { queryKeys } from '@/shared/lib/queryKeys';
import type { ReviewHistoryEntry } from '@/shared/types/domain';

/**
 * As decisões dos últimos 30 dias (decisão 28).
 *
 * `enabled` é decisão de quem chama, como em `useReviewQueue`: para quem não
 * tem `reviewProject`, NENHUMA das duas consultas dispara — a tela inteira é
 * de outra plateia (§6.3 da 1ª rodada).
 */
export function useReviewHistory(enabled = true): UseQueryResult<ReviewHistoryEntry[]> {
  return useQuery({
    queryKey: queryKeys.reviewHistory,
    queryFn: fetchReviewHistory,
    enabled,
    staleTime: 30_000,
  });
}
